define('CustomLazyLoading/CustomLazyLoading',[
],
    function () {
        function init() {
            const lazyLoadingClassSelector = ".custom-lazy-loading";
            const lazyLoadingClassName = "custom-lazy-loading";
            
            function handleCustomLazyLoading(evt) {
                var eventTrigger = evt.currentTarget.eventTrigger;
                var eventTarget = evt.currentTarget.eventTarget;
                var eventName = evt.currentTarget.eventName;                
                var jqueryEl = $(evt.target).find(eventTarget);
                if (evt.target.tagName.toLowerCase() == "a")
                    jqueryEl = $(evt.target).parent().find(eventTarget);

                var isVisible = $(jqueryEl).is(":visible");                
                if (isVisible) {
                    $(jqueryEl).find(lazyLoadingClassSelector).each(function (index, element) {
                        var src = $(this).attr("data-src");
                        $(this).attr("src", src);
                        $(this).removeClass(lazyLoadingClassName);
                    });                   
                    $(evt.target).closest(eventTrigger)[0].removeEventListener(eventName, handleCustomLazyLoading);
                }
            }

            $(document).ready(function () {
                var lazyloadImages;

                if ("IntersectionObserver" in window) {
                    lazyloadImages = document.querySelectorAll(lazyLoadingClassSelector);
                    var imageObserver = new IntersectionObserver(function (entries, observer) {
                        entries.forEach(function (entry) {

                            if (entry.isIntersecting) {
                                var image = entry.target;
                                var eventTrigger = $(image).data("eventTrigger");
                                var eventTarget = $(image).data("eventTarget");
                                var eventName = $(image).data("eventName");
                                var eventTriggerObj = $(image).closest(eventTrigger);
                                var eventTriggerElement = eventTriggerObj[0];
                                eventTriggerElement.eventTrigger = eventTrigger;
                                eventTriggerElement.eventTarget = eventTarget;
                                eventTriggerElement.eventName = eventName;                                
                                eventTriggerElement.addEventListener(eventName, handleCustomLazyLoading);

                                imageObserver.unobserve(image);
                            }
                        });
                    });

                    lazyloadImages.forEach(function (image) {
                        imageObserver.observe(image);
                    });
                } else {

                    var lazyloadThrottleTimeout;
                    lazyloadImages = document.querySelectorAll(lazyLoadingClassSelector);

                    function lazyload() {
                        if (lazyloadThrottleTimeout) {
                            clearTimeout(lazyloadThrottleTimeout);
                        }

                        lazyloadThrottleTimeout = setTimeout(function () {
                            var scrollTop = window.pageYOffset;
                            lazyloadImages.forEach(function (img) {
                                if (img.offsetTop < (window.innerHeight + scrollTop)) {
                                    img.src = img.dataset.src;
                                    img.classList.remove(lazyLoadingClassName);
                                }
                            });
                            if (lazyloadImages.length == 0) {
                                document.removeEventListener("scroll", lazyload);
                                window.removeEventListener("resize", lazyload);
                                window.removeEventListener("orientationChange", lazyload);
                            }
                        }, 20);
                    }

                    document.addEventListener("scroll", lazyload);
                    window.addEventListener("resize", lazyload);
                    window.addEventListener("orientationChange", lazyload);
                }               
            });
        }

        return {
            init: init
        };
    }
);

